import Layout from "layout/Layout";
import SettingsData from "./components/SettingsData";

const Settings = () => {
    return (
        <Layout>
            <SettingsData />
        </Layout>
    )
}

export default Settings;